// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__SZkqc","info":"Note_info__3SeZo","note":"Note_note__3l6XD","actions":"Note_actions__3UL1O"};